export default __webpack_public_path__ + "static/media/00DEC85C-00.1e5fca1d.png";